module.exports = __webpack_public_path__ + "img/gz.7955de99.jpg";